import React from 'react';

import styled from 'styled-components';

import Input from 'components/lib/Input';
import Select from 'components/lib/Select';

import { useCompaniesCreateEditModalContext } from './CompaniesCreateEditModalContext';
import { COMPANY_KEYS, COMPANY_MYSTERY_SHOP_SETTING_INITIAL_VALUES } from './constants';
import { COMPANY_STATUS, COMPANY_STATUS_OPTIONS } from '../constants';

const Container = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 20px;
`;

const Label = styled.div`
  font-size: 14px;
  margin-right: 10px;
  font-family: var(--font-bold);
  color: var(--text-primary);
  min-width: 140px;
  display: flex;
  justify-content: flex-end;
  &.status {
    min-width: auto;
  }
`;

const StyledInput = styled(Input)`
  width: 342px;
  height: 36px;
  margin-right: 20px;
`;

const StyledSelect = styled(Select)`
  && .ant-select-selector {
    border-radius: 0; !important;
  }
  && .ant-select-selection-item {
    font-size: 14px; !important;
    color: var(--text-primary); !important;
  }
`;

const CompaniesCreateEditModalContentBasic = () => {
  const { company, handleChange } = useCompaniesCreateEditModalContext();

  const handleStatusChange = (value: any) => {
    if ([COMPANY_STATUS.OUTSIDE_COMPANY, COMPANY_STATUS.DEMO].includes(value)) {
      handleChange(COMPANY_KEYS.MYSTERY_SHOP_SETTING, {});
    } else if (value === COMPANY_STATUS.IN_TRIAL) {
      handleChange(COMPANY_KEYS.MYSTERY_SHOP_SETTING, {
        ...(company?.mystery_shop_setting?.shop_priority
          ? { shop_priority: company.mystery_shop_setting.shop_priority }
          : {}),
      });
    } else {
      const shopPriority = company?.mystery_shop_setting?.shop_priority;

      const newSettings = {
        ...COMPANY_MYSTERY_SHOP_SETTING_INITIAL_VALUES,
        ...(shopPriority ? { shop_priority: shopPriority } : {}),
      };
      handleChange(COMPANY_KEYS.MYSTERY_SHOP_SETTING, newSettings);
    }

    handleChange(COMPANY_KEYS.STATUS, value);
  };

  return (
    <Container>
      <Label>Company Name</Label>
      <StyledInput
        placeholder="Enter Company Name"
        value={company?.name || ''}
        onChange={(e: any) => handleChange(COMPANY_KEYS.NAME, e.target.value)}
      />
      <Label className="status">Status</Label>
      <StyledSelect
        placeholder="Select Status"
        options={COMPANY_STATUS_OPTIONS}
        defaultValue={COMPANY_STATUS_OPTIONS[2]}
        value={company?.status}
        style={{ height: '36px', width: '200px' }}
        onChange={handleStatusChange}
      />
    </Container>
  );
};

export default CompaniesCreateEditModalContentBasic;
